import { render, staticRenderFns } from "./facility.vue?vue&type=template&id=176095c6&"
import script from "./facility.vue?vue&type=script&lang=js&"
export * from "./facility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports